import { z } from 'zod';
import excludedEmailDomains from '../constants/excludedEmailDomains';
import { marketingOptOutSchema } from '../components/MarketingOptOut/validation';

const FIRST_NAME_MAX_LENGTH = 40;
const LAST_NAME_MAX_LENGTH = 80;
const COMPANY_MAX_LENGTH = 40;
const EMAIL_MAX_LENGTH = 80;
const PHONE_MAX_LENGTH = 40;

export const getContactFormSchema = (options?: { isRequestTypeFieldRequired: boolean }) =>
  z.object({
    first_name: z.string().max(FIRST_NAME_MAX_LENGTH).min(1, 'form.Required field'),
    last_name: z.string().max(LAST_NAME_MAX_LENGTH).min(1, 'form.Required field'),
    company: z.string().max(COMPANY_MAX_LENGTH).min(1, 'form.Required field'),
    email: z
      .string()
      .min(1, 'form.Required field')
      .email('form.Invalid email format')
      .max(EMAIL_MAX_LENGTH)
      .transform((value) => value.toLowerCase())
      .refine(
        (value) => !excludedEmailDomains.some((domain) => value.includes(domain)),
        'form.Company email domains only'
      ),
    phone: z.string().max(PHONE_MAX_LENGTH).optional(),
    country: z
      .object({
        label: z.string(),
        value: z.string(),
      })
      .nullable()
      .transform((data, ctx) => {
        if (data === null) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'form.Required field',
          });

          return z.NEVER;
        }

        return data.value;
      }),
    message: z.string().min(1, 'form.Message is required'),
    request_type: z
      .object({
        label: z.string(),
        value: z.string(),
      })
      .nullable()
      .transform((data, ctx) => {
        if (data === null) {
          if (options?.isRequestTypeFieldRequired) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'form.Required field',
            });

            return z.NEVER;
          }
          return null;
        }

        return data?.value;
      }),
    number_of_developers: z
      .object({
        label: z.string(),
        value: z.string(),
      })
      .nullable()
      .transform((data) => data?.value),
    scope: z.union([z.literal('contact'), z.literal('sonarcloud_enterprise')]),
    form_type: z.literal('contact'),
    campaign_id: z.string().optional(),
    ...marketingOptOutSchema.shape,
  });
